<div class="glovo-bags-master">
  <p class="glovo-bags-master__intro">
    {{ 'COMMON.BAGS_MASTER.INTRO' | translate }}
  </p>

  <table class="glovo-bags-master__table table">
    <thead>
      <tr>
        <th scope="col">{{ 'COMMON.BAGS_MASTER.TABLE.NAME' | translate }}</th>
        <th scope="col">{{ 'COMMON.BAGS_MASTER.TABLE.EMAIL' | translate }}</th>
        <th scope="col">{{ 'COMMON.BAGS_MASTER.TABLE.FREE_BAGS' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let slave of customer?.slaves">
        <th scope="row">{{ slave.name ? slave.name : slave.emailLogin }}</th>
        <td>{{ slave.emailLogin }}</td>
        <td>{{ slave.procurementCreditsSfTotal }}</td>
      </tr>
    </tbody>
  </table>
  <p class="glovo-bags-master__disclaimer"
    [innerHTML]="'COMMON.BAGS_MASTER.DISCLAIMER' | translate: { link: link }"></p>
</div>
